// @flow

// Libs
import React from 'react'
import { styles as s } from './style'
import { OrderTestsOperation } from 'hfty-operator-order-tests/types'
import { Errors } from 'hfty-components-errors'
import { FormattedMessage } from 'react-intl'
import messages from '../../messages'
import { SUPPORT_PHONE_NUMBER } from 'hfty'
import { BillingPopUp } from 'hfty-components-confirm-billing'
import _forEach from 'lodash/forEach'
import _findIndex from 'lodash/findIndex'
import _without from 'lodash/without'
import _reduce from 'lodash/reduce'
import _find from 'lodash/find'
import _indexOf from 'lodash/indexOf'
import _isEqual from 'lodash/isEqual'
import _has from 'lodash/has'
import moment from 'moment'

// Constants
import {
  PROP_SOIL_JOB_ID,
  PROP_CREATED_DATE,
  PROP_FIELD,
} from 'hfty-model-soil-jobs'
import {
  PROP_COUNTRY,
  PROP_USER_BILLING_INFO,
  PROP_ADDRESS,
  PROP_CITY,
  PROP_PROVINCE,
  PROP_POSTAL_CODE,
  PROP_SUPPLY_QUANTITY,
} from 'hfty-model-orders'

type Props = {
  currentUser: Object,
  jobs: Array,
  fields: Array,
  operation: OrderTestsOperation,
  onSubmit: Function,
  onCancel: Function,
  onChange: Function,
  createOrder: Function,
  updateUserBillingInfo: Function,
}

type State = {
  billingPopUpIsOpen: boolean,
}

export default class TestsTable extends React.Component<Props> {
  props: Props
  state: State

  constructor (props: Props) {
    super(props)

    this.state = {
      billingPopUpIsOpen: false,
    }

    this.onSelectRow = this.onSelectRow.bind(this)
    this.calculatePrice = this.calculatePrice.bind(this)
    this.canSubmit = this.canSubmit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onCancel = this.onCancel.bind(this)
    this.handleBillingPopUpActions = this.handleBillingPopUpActions.bind(this)
    this.getReversedBillingModel = this.getReversedBillingModel.bind(this)
    this.checkIfUserBillingInfoWasChanged = this.checkIfUserBillingInfoWasChanged.bind(this)
    this.askRememberBillingInfo = this.askRememberBillingInfo.bind(this)
  }

  componentDidMount () {
    this.props.createOrder()
  }

  canSubmit (): boolean {
    return this.props.operation.model.jobs.length > 0
  }

  calculatePrice (): number {
    const operation = this.props.operation
    const jobs = this.props.jobs
    const onChange = this.props.onChange
    _forEach(operation.model.jobs, function (jobId: number) {
      if (_findIndex(jobs, {id: jobId}) < 0) {
        onChange({
          ...operation,
          model: {
            ...operation.model,
            jobs: _without(operation.model.jobs, jobId),
          },
        })
      }
    })
    return _reduce(operation.model.jobs, function (price: number, nextId: number): number {
      let job = _find(jobs, {id: nextId})
      if (job) {
        return price + (job.price < 25 ? 25 : job.price)
      }
      return price
    }, 0)
  }

  onSelectRow (row: Object, x: Object) {
    const alreadySelected = _indexOf(this.props.operation.model.jobs, row.id) >= 0
    const selectedJobIds = alreadySelected
      ? _without(this.props.operation.model.jobs, row.id)
      : [...this.props.operation.model.jobs, row.id]
    const supplyQuantity = _reduce(selectedJobIds, (acc: number, jobId: number): number => {
      const availableJobs = this.props.jobs || []
      const job = availableJobs.find((job) => job.id === jobId)
      const samplingNumber = job ? job.samplingPoints : 0
      acc += samplingNumber

      return acc
    }, 0)

    this.props.onChange({
      ...this.props.operation,
      model: {
        ...this.props.operation.model,
        jobs: selectedJobIds,
        order: {
          ...this.props.operation.model.order,
          [PROP_SUPPLY_QUANTITY]: supplyQuantity,
        },
      },
    })
  }

  askRememberBillingInfo (): boolean {
    return localStorage.getItem('rememberBillingInfo')
      ? !localStorage.getItem('rememberBillingInfo') === 'true'
      : true
  }

  onSubmit () {
    if (this.askRememberBillingInfo()) {
      this.setState({
        ...this.state,
        billingPopUpIsOpen: true,
      })
    } else {
      this.props.onSubmit(this.props.operation)
    }
  }

  onCancel () {
    this.props.onCancel(this.props.operation)
  }

  getReversedBillingModel (): Object {
    const { currentUser: { clientBillingAddress } } = this.props

    return {
      [PROP_ADDRESS]: clientBillingAddress[PROP_ADDRESS],
      [PROP_CITY]: clientBillingAddress[PROP_CITY],
      [PROP_COUNTRY]: clientBillingAddress[PROP_COUNTRY],
      [PROP_PROVINCE]: clientBillingAddress[PROP_PROVINCE],
      [PROP_POSTAL_CODE]: clientBillingAddress[PROP_POSTAL_CODE],
    }
  }

  checkIfUserBillingInfoWasChanged (): boolean {
    const { operation, currentUser: { clientBillingAddress } } = this.props
    const previousUserBillingInfo = {
      [PROP_ADDRESS]: clientBillingAddress[PROP_ADDRESS],
      [PROP_CITY]: clientBillingAddress[PROP_CITY],
      [PROP_COUNTRY]: clientBillingAddress[PROP_COUNTRY],
      [PROP_PROVINCE]: clientBillingAddress[PROP_PROVINCE],
      [PROP_POSTAL_CODE]: clientBillingAddress[PROP_POSTAL_CODE],
    }
    const currentUserBillingInfo = operation.model[PROP_USER_BILLING_INFO]

    return !_isEqual(previousUserBillingInfo, currentUserBillingInfo)
  }

  handleBillingPopUpActions (actionType: string, payload: Object) {
    const { operation } = this.props

    switch (actionType) {
      case 'update':
        this.props.onChange({
          ...operation,
          model: {
            ...operation.model,
            [PROP_USER_BILLING_INFO]: {
              ...operation.model[PROP_USER_BILLING_INFO],
              [payload.field]: payload.value,
            },
          },
        })
        break

      case 'submit':
        const isBillingInfoChanged = this.checkIfUserBillingInfoWasChanged()

        if (!isBillingInfoChanged) {
          this.setState({
            ...this.state,
            billingPopUpIsOpen: false,
          }, () => {
            this.props.onSubmit(this.props.operation)
          })
        } else {
          this.setState({
            ...this.state,
            billingPopUpIsOpen: false,
          }, () => {
            this.props.updateUserBillingInfo({
              ...operation.model[PROP_USER_BILLING_INFO],
              orderTestOperation: this.props.operation,
            })
          })
        }
        break

      case 'cancel':
        this.setState({
          ...this.state,
          billingPopUpIsOpen: false,
        }, () => {
          this.props.onChange({
            ...operation,
            model: {
              ...operation.model,
              [PROP_USER_BILLING_INFO]: {
                ...this.getReversedBillingModel(),
              },
            },
          })
        })
    }
  }

  render (): React.Element<any> {
    if (this.props.operation) {
      const op = this.props.operation
      const successLoading = op.model.jobs.length && op.success
      return (
        <div>
          <div style={s.tableWrapper}>
            <BillingPopUp
              isOpen={this.state.billingPopUpIsOpen}
              onCancel={(): Function => this.handleBillingPopUpActions('cancel')}
              onSubmit={(): Function => this.handleBillingPopUpActions('submit')}
              onUpdate={(payload: Object): Function => this.handleBillingPopUpActions('update', payload)}
              userBillingInfo={this.props.operation.model[PROP_USER_BILLING_INFO]}
              isBillingInfoChanged={this.checkIfUserBillingInfoWasChanged()}
            />
            <div style={s.table}>
              <Errors
                errors={op.errors}
                messages={messages}
              />
            </div>
            {successLoading
              ? <div style={s.success}><FormattedMessage {...messages['successMsg']} /></div>
              : null
            }
            <table style={s.table}>
              <thead>
                <tr>
                  <th style={s.tableHeadCellCheckbox}>
                    <input disabled={successLoading} type='checkbox' /></th>
                  <th style={s.tableHeadCell}>ID</th>
                  <th style={s.tableHeadCell}>Date</th>
                  <th style={s.tableHeadCellField}>Field</th>
                  <th style={s.tableHeadCell}>Area**</th>
                  <th style={s.tableHeadCell}># Samples</th>
                  <th style={s.tableHeadCell}>Price</th>
                </tr>
              </thead>

              <tbody>
                { this.props.jobs.map((row: Object, key: number): any => {
                  let field = _find(this.props.fields, {id: row[PROP_FIELD]})
                  return (
                    <tr key={key} style={s.tableBodyRow}>
                      <td>
                        <input
                          onChange={(): Function => this.onSelectRow(row)}
                          type='checkbox'
                          disabled={successLoading}
                          checked={_indexOf(op.model.jobs, row.id) >= 0}
                        />
                      </td>
                      <td>{ row[PROP_SOIL_JOB_ID] }</td>
                      <td>{ moment(row[PROP_CREATED_DATE], 'X').format('DD MMM YY') }</td>
                      <td>{ _has(field, 'label') ? field.label : '' }</td>
                      <td>{ row.area && row.area.toFixed(2) }</td>
                      <td>{ row.samplingPoints }</td>
                      <td>{ _has(row, 'price') ? '$' + row.price.toFixed(2) : null }</td>
                    </tr>
                  )
                }) }
                <tr style={s.totalRow}>
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td>Total Price</td>
                  <td>{'$' + this.calculatePrice().toFixed(2)}</td></tr>
              </tbody>
            </table>
          </div>
          <div style={s.footer}>
            <span style={s.footerDescription}>
              Select the jobs you wish to order and click Place Order.
              Questions? Call us: {SUPPORT_PHONE_NUMBER}
            </span>
            <button
                style={this.canSubmit() ? s.submitButton : {...s.submitButton, backgroundColor: 'gray'}}
                disabled={!this.canSubmit() || op.submitting}
                onClick={successLoading ? null : this.onSubmit}
              >
              {successLoading || op.submitting ? 'Processing....' : 'Place Order'}
            </button>
            <span style={s.minimumCharge}>
              *Minimum charge applies
            </span>
            <span style={s.minimumCharge}>
              **Acres rounded up
            </span>
          </div>
        </div>
      )
    }

    return null
  }
}
